import styled from "styled-components";
import { FontStyles } from "../../../components";
import { Colors } from "../../../config";

const iconStyles = {
  paddingRight: 5,
  width: 24,
  height: 24,
  marginRight: 4,
  fill: "black",
  filter: "invert(1)",
  minWidth: 24,
};

const Container = styled.div(({ theme }) => {
  const { palette: colors, breakpoints } = theme as any;
  return {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100vh",
    width: "min-content",
    justifyContent: "space-between",
    background: colors.background.default,
    position: "relative",
    boxShadow: "0px 0px 4px #00000014",
    maxWidth: "20vw",
    minWidth: "20vw",
    zIndex: 90,
    [breakpoints.down("sm")]: {
      maxWidth: "100vw",
      minWidth: "20vw",
    },
  };
});

const ShowQuery = styled.div(({ theme }) => {
  const { palette: colors, breakpoints } = theme as any;
  return {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100vh",
    width: "min-content",
    backgroundColor: Colors.black,
    position: "relative",
    boxShadow: "0px 0px 4px #00000014",
    maxWidth: "20vw",
    minWidth: "20vw",
    zIndex: 90,
    [breakpoints.down("xxl")]: {
      width: 0,
      maxWidth: 0,
      minWidth: 0,
    },
  };
});

const Background = styled.div(() => {
  return {
    marginLeft: "auto",
    height: "100%",
  };
});

const SubLogo = styled.p(({ theme }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    ...FontStyles.bold16,
    marginInline: spacing(3),
    letterSpacing: 1,
    fontWeight: "600",
    color: colors.text.primary,
    marginTop: spacing(3),
  };
});

const Line = styled.div(({ theme }) => {
  const { palette: colors } = theme as any;
  return {
    backgroundColor: colors.white,
    width: "100%",
    height: 1,
  };
});

const ScrollContainer = styled.div(({ theme }) => {
  const { spacing } = theme as any;
  return {
    overflow: "auto",
    width: "100%",
    marginRight: spacing(3.75),
  };
});

const Group = styled.div<{ $withoutPadding?: boolean }>(({ theme, $withoutPadding }) => {
  const { spacing, breakpoints } = theme as any;
  return {
    display: "flex",
    flexDirection: "column",
    paddingBottom: $withoutPadding ? 0 : spacing(1),
    marginTop: spacing(2),
    [breakpoints.down("md")]: {
      padding: `0 ${spacing(2)}px ${$withoutPadding ? 0 : spacing(1)}px ${spacing(2)}px`,
    },
  };
});

const GroupTitle = styled.p(({ theme }) => {
  const { palette: colors } = theme as any;
  return {
    margin: 0,
    color: colors.primary.contrastText,
    ...FontStyles.semibold12,
  };
});

const GroupNameContainer = styled.div({
  display: "flex",
  alignItems: "center",
});

const GroupTitleContainer = styled.div(({ theme }) => {
  const { spacing, breakpoints } = theme as any;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `0 ${spacing(5)}px`,
    marginBottom: spacing(1),
    [breakpoints.down("md")]: {
      padding: `0 ${spacing(2)}px`,
    },
  };
});

const Page = styled.a<{
  $disabled?: boolean;
  $buttonContained?: boolean;
  $currentPage?: boolean;
  alternative?: boolean;
  subPages?: boolean;
}>(
  ({
    theme,
    $disabled,
    $buttonContained,
    $currentPage,
    alternative,
    subPages,
  }) => {
    const { spacing, palette: colors, breakpoints } = theme as any;
    return {
      justifyContent: " space-between",
      color: $buttonContained ? "red" : "yellow",
      cursor: $disabled || subPages ? "default" : "pointer",
      display: "flex",
      alignItems: "center",
      opacity: $disabled ? 0.55 : 1,
      margin: $buttonContained ? "auto" : undefined,
      marginLeft: spacing(5),
      ...FontStyles.medium12,

      "&:hover": {
        backgroundColor:
          $disabled || alternative ? undefined : colors.text.primary + 30,
      },
      borderRight: $currentPage
        ? `${spacing(0.5)}px solid ${colors.primary.contrastText}`
        : undefined,

      [breakpoints.down("md")]: {
        padding: `0 ${spacing(1)}px`,
        marginLeft: 0,
      },
    };
  }
);

const PageLine = styled.div<{ $currentPage?: boolean }>(
  ({
    theme,
    $currentPage,
  }) => {
    const { spacing, palette: colors } = theme as any;
    return {
      borderRight: $currentPage
        ? `${spacing(1)}px solid ${colors.primary.contrastText}`
        : undefined,
      paddingRight: spacing(0.5),
    };
  }
);

const PageContent = styled.div<{ alternative?: boolean; $currentPage?: boolean }>(({ theme, alternative }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    color: !alternative ? colors.primary.contrastText : colors.primary.main,
    ...FontStyles.medium14,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginRight: spacing(3),
    width: "max-content",
    marginBlock: spacing(0.25),
    backgroundColor: alternative ? "white" : undefined,
    paddingInline: alternative ? spacing(2) : undefined,
    paddingBlock: alternative ? spacing(0.4) : undefined,
    borderRadius: alternative ? spacing(20) : undefined,
  };
});

const Premium = styled.div(({ theme }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    background: "white",
    color: colors.text.tertiary,
    borderRadius: spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `0 ${spacing(2)}px`,
  };
});

const SubGroup = styled.div(() => ({
  transition: "1s",
  overflow: "hidden",
  height: "unset",
}));

const ContactContent = styled.div(({ theme }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    width: "100%",
    padding: spacing(3.5),
    backgroundColor: colors.background.input,
  };
});

const TitleModal = styled.p(({ theme }) => {
  const { palette: colors } = theme as any;
  return {
    ...FontStyles.bold14,
    textTransform: "uppercase",
    color: colors.text.secondary,
  };
});

const InfoModal = styled.p(({ theme }) => {
  const { palette: colors } = theme as any;
  return {
    ...FontStyles.medium16,
    color: colors.text.secondary,
  };
});

const ModalPadding = styled.div(({ theme }) => {
  const { spacing } = theme as any;
  return {
    paddingInline: spacing(3.5),
    overflow: "auto",
    height: "100%",
  };
});

const Notification = styled.p(({ theme }) => {
  const { palette: colors, spacing } = theme as any;
  return {
    ...FontStyles.bold10,
    color: colors.text.tertiary,
    backgroundColor: colors.white,
    borderRadius: spacing(1.25),
    letterSpacing: spacing(0.041),
    padding: `${spacing(0.25)}px ${spacing(1.5)}px`,

    marginRight: spacing(1.25),
  };
});

const BlueBullet = styled.li(({ theme }) => {
  const { palette: colors } = theme as any;
  return {
    color: 'blue',
    fontSize: 20,
  };
});

const Header = styled.div(({ theme }) => {
  const { spacing } = theme as any;
  return {
    filter: "brightness(0) invert(1)",
    padding: `${spacing(3.5)}px ${spacing(2.2)}px`,
    paddingLeft: spacing(5),
    paddingBottom: spacing(2),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  };
});

const Icon = styled.img<{ $color?: number }>(({ theme, $color }) => {
  const { spacing } = theme as any;
  return {
    paddingRight: spacing(0.625),
    width: spacing(3),
    height: spacing(3),
    marginRight: spacing(0.5),

    filter:
      $color === 2
        ? "invert(15%) sepia(0%) saturate(2790%) hue-rotate(256deg) brightness(106%) contrast(81%)"
        : $color === 1
        ? "invert(49%) sepia(94%) saturate(313%) hue-rotate(75deg) brightness(98%) contrast(93%)"
        : "invert(1)",

    minWidth: 24,
  };
});

const Styles = {
  Header,
  Container,
  Background,
  SubLogo,
  Line,
  GroupTitle,
  Group,
  GroupNameContainer,
  iconStyles,
  Page,
  GroupTitleContainer,
  SubGroup,
  ScrollContainer,

  Premium,
  ContactContent,
  InfoModal,
  TitleModal,
  ModalPadding,
  Notification,
  PageContent,
  BlueBullet,
  ShowQuery,
  PageLine,
  Icon,
};

export default Styles;
